import React, { MouseEvent } from 'react';
import { Button } from '../../../basic/Button/Button';
import './CardButtons.scss';
import iconAgree from '../../../../styles/assets/icons/agree.svg';
import iconAgreeWhite from '../../../../styles/assets/icons/agree-white.svg';
import iconDisagree from '../../../../styles/assets/icons/disagree.svg';
import iconDisagreeWhite from '../../../../styles/assets/icons/disagree-white.svg';

type ButtonClick = (e: MouseEvent<HTMLButtonElement>) => void;

interface ICardButtonsProps {
  handleLikeClick: ButtonClick;
  handleDislikeClick: ButtonClick;
  handleDetailsClick?: ButtonClick | undefined;
  showCopyLinkButton?: boolean;
  hideHints?: boolean;
  isLiked?: boolean;
  isDisliked?: boolean;
  isLikePressed?: boolean;
  isDislikePressed?: boolean;
};

export function CardButtons({ handleLikeClick, handleDislikeClick, handleDetailsClick, hideHints, showCopyLinkButton, isLiked, isDisliked, isLikePressed, isDislikePressed }: ICardButtonsProps) {
  const renderDetailsButton = () => (
    <li className='CardButtons__button-hint-wrapper'>
      <Button buttonType='main' text='Details' handleClick={handleDetailsClick} />
      {
        hideHints
          ? null
          : (
            <>
              <div className='CardButtons__vertical-line'></div>
              <div className='CardButtons__button-hint'>
                <p>Read more,</p>
                <p>comments,</p>
                <p>etc.</p>
              </div>
            </>
          )
      }
    </li>
  );

  const handleCopyLinkClick = () => {
    const url = window.location.href;

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    alert('The post link is copied to clipboard.');
  };

  const renderCopyLinkButton = () => (
    <li className='CardButtons__button-hint-wrapper'>
      <Button buttonType='main' text='Copy Link' handleClick={handleCopyLinkClick} />
      {
        hideHints
          ? null
          : (
            <>
              <div className='CardButtons__vertical-line'></div>
              <div className='CardButtons__button-hint'>
                <p>Copy current</p>
                <p>link to</p>
                <p>clipboard.</p>
              </div>
            </>
          )
      }
    </li>
  );

  return (
    <ul className='CardButtons'>
      
      <li className='CardButtons__small-buttons'>  

        <div className='CardButtons__button-hint-wrapper'>
          <Button
            isPressed={isLiked || isLikePressed}
            isDisabled={isDisliked}
            buttonType='neutral'
            icon={isDisliked ? iconAgreeWhite : iconAgree}
            handleClick={handleLikeClick}
          />
          {
            hideHints
              ? null
              : (
                <div className={ isDisliked ? 'CardButtons__transparent' : '' }>
                  <div className='CardButtons__vertical-line'></div>
                  <div className='CardButtons__button-hint'>
                    <p>Agree</p>
                    <p>with</p>
                    <p>author</p>
                  </div>
                </div>
              )
          }
        </div>
        
        <div className='CardButtons__button-hint-wrapper'>
          <Button
            isPressed={isDisliked || isDislikePressed}
            isDisabled={isLiked}
            buttonType='neutral'
            icon={isLiked ? iconDisagreeWhite : iconDisagree}
            handleClick={handleDislikeClick}
          />

          {
            hideHints
              ? null
              : (
                <div className={ isLiked ? 'CardButtons__transparent' : '' }>
                  <div className='CardButtons__vertical-line'></div>
                  <div className='CardButtons__button-hint'>
                    <p>Disagree</p>
                  </div>
                </div>
              )
          }
        </div>

      </li>


      {
        handleDetailsClick
          ? renderDetailsButton()
          : null
      }

      {
        showCopyLinkButton
          ? renderCopyLinkButton()
          : null
      }

    </ul>
  );
}
